import { TWorkflowExecution } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { WORKFLOW_EXECUTION_BASE_URL } from './helpers';

export const useWorkflowExecution = (workflowExecutionId: string) => {
  // Legacy service requests have no execution; without this the hook spams
  // `workflow-execution/` and SWR retries the 404 forever.
  const url = workflowExecutionId
    ? `${WORKFLOW_EXECUTION_BASE_URL}/${workflowExecutionId}`
    : null;

  const { data, error, isLoading, mutate } = useSWR<TWorkflowExecution>(
    url,
    SWRFetcher({
      method: 'GET',
    })
  );

  return { data, error, isLoading, mutate };
};
